import Header from "./Header";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import { Box, Container } from "@mui/material";

const Layout = ({ children }) => {
const bgImage1 = "Global/bg2.jpeg"
  const s3URL = "https://canberrahebron.s3.eu-north-1.amazonaws.com/";

  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100vw",
        overflowX: "hidden",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${s3URL + bgImage1})`,
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          p: isHome ? 0 : { xs: 2, md: 4 },
        }}
      >
        {isHome ? children : (
          <Container
            maxWidth="xl"
            sx={{
              textAlign: "center",
              backgroundColor: "transparent",
              p: { xs: 2, md: 4 },
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            {children}
          </Container>
        )}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
